
import { Component, Vue } from "vue-property-decorator";
import AdmIconButton from "@afe/admirals-dev/src/components/AdmIconButton";
import "./popup.scss";

@Component({
  components: { AdmIconButton }
})
export default class extends Vue {
  isShown = false;
  body = document.body;

  onClick() {
    this.isShown = !this.isShown;
    this.isShown
      ? this.body.classList.add("adm-popup-open")
      : this.body.classList.remove("adm-popup-open");
  }
}
